<template>
  <div>
    <ul class="unstyled-list type-small" v-if="!isLoggedIn">
      <li>
        <a class="main-footer__item" href="/register">Create an Account</a>
      </li>
      <li>
        <a class="main-footer__item" href="/login">Login</a>
      </li>
    </ul>
    <div
      v-else>
      <ul class="unstyled-list type-small">
        <li>
          <a class="main-footer__item" href="/customer/myaccount/">Dashboard</a>
        </li>
        <li>
          <a class="main-footer__item" href="/customer/myaccount/">Licenses</a>
        </li>
        <li>
          <a class="main-footer__item" href="/customer/orders/">Shop History</a>
        </li>
        <li v-if="!customer.ClientAccount">
          <a class="main-footer__item" :href="adminLink">Administration</a>
        </li>
        <li>
          <button
            type="button"
            @click.prevent="logout">
            Logout
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { FETCH_CUSTOMER_LOGOUT } from '../vuex/modules/auth/mutations';

// import { mapState } from 'vuex';

export default {
  name: 'FooterMenuLogin',
  data() {
    return {

    }
  },
  methods: {
     ...mapActions({
      FETCH_CUSTOMER_LOGOUT,
    }),

    logout() {
      this.FETCH_CUSTOMER_LOGOUT();
    },

  },


  computed: {
    ...mapState({
      isLoggedIn: state => state.AuthStore.isLoggedIn,
      customer: state => state.AuthStore.customer,
    }),

    adminLink() {
      return (window.env.ZOHRAB_SHOP_DOMAIN)+'/admin';
    }

  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/FooterMenuLogin.vue